import './../css/GSideBar.css';
import './../css/GPostJob.css';
import './../css/GMediaQuery.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { systemConfiguration } from '../../../src/CommonImports';
import { useEffect, useState } from '../../../src/InBuildImports';
import skillsData from "../staticjson/GCandidateSingleJson/candidateSkills.json";
import workExpData from "../staticjson/GCandidateSingleJson/workExperience.json";
import educationData from "../staticjson/GCandidateSingleJson/education.json";



function GCandidateInfo({ }) {

    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    const [editingWorkId, setEditingWorkId] = useState(null);
    const [editingEducationId, setEditingEducationId] = useState(null);
    const [editingSkillId, setEditingSkillId] = useState(null);

    const [isEditing, setIsEditing] = useState(false);
    const [skills, setSkills] = useState(skillsData);

    const [workExperience, setWorkExperience] = useState(workExpData);
    const [isEditingExperience, setIsEditingExperience] = useState(false);
    const [experienceErrors, setExperienceErrors] = useState({});

    const [educationList, setEducationList] = useState(educationData);
    const [isEditingEducation, setIsEditingEducation] = useState(false);
    const [educationErrors, setEducationErrors] = useState({});

    const validateExperience = (item) => {
        const errors = {};
        if (!item.company?.trim()) {
            errors.company = "Company is required";
        }
        if (!item.role?.trim()) {
            errors.role = "Role is required";
        }
        if (!item.location?.trim()) {
            errors.location = "Location is required";
        }
        if (!item.startDate) {
            errors.startDate = "Start date is required";
        }
        return errors;
    };

    const validateEducation = (item) => {
        const errors = {};

        if (!item.university?.trim()) {
            errors.university = "University is required";
        }
        if (!item.course?.trim()) {
            errors.course = "Course is required";
        }
        if (!item.location?.trim()) {
            errors.location = "Location is required";
        }
        if (!item.startDate) {
            errors.startDate = "Start date is required";
        }

        return errors;
    };

    const handleSaveExperience = (item, index) => {
        const errors = validateExperience(item);
        if (Object.keys(errors).length > 0) {
            setExperienceErrors(errors);
            return;
        }
      
        setExperienceErrors({});
        setEditingWorkId(null);
    };

    const handleAddExperience = () => {    
        const hasIncompleteExperience = workExperience.some(
            (item) =>
                !item.company?.trim() ||
                !item.role?.trim() ||
                !item.location?.trim() ||
                !item.startDate?.trim()
        );

        if (hasIncompleteExperience) {
            alert("Please complete the current Work Experience before adding new one.");
            return;
        }

        const newItem = {
            id: Date.now() + Math.random(),
            company: "",
            role: "",
            location: "",
            description: "",
            startDate: "",
            durationType: "Present"
        };

        setWorkExperience((prev) => [...prev, newItem]);
        setEditingWorkId(newItem.id);
    };

    const handleExperienceChange = (index, field, value) => {
        setWorkExperience((prev) => {
            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                [field]: value
            };

            return updated;
        });

    };

    const handleRemoveExperience = (id, index) => {
        if (index === 0) {
            alert("First Work Experience cannot be removed.");
            return;
        }
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this Work Experience?"
        );
        if (!confirmDelete) return;
        setWorkExperience((prev) =>
            prev.filter((item) => item.id !== id)
        );
        if (editingWorkId  === id) {
            setEditingWorkId(null);
        }
    };


    const [educationDescription, setEducationDescription] = useState(
        `Completed academic education with strong knowledge in software development,
            web technologies, UI/UX design, and modern application architecture.
            Focused on practical implementation and real-time project development.`
    );

    const handleEducationChange = (index, field, value) => {
        setEducationList((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [field]: value
            };
            return updated;
        });
    };

    const handleSaveEducation = (item, index) => {
    
        const errors = validateEducation(item);
        if (Object.keys(errors).length > 0) {
            setEducationErrors(errors);
            return;
        }
        setEducationErrors({});
        setEditingEducationId(null);
    };

   const handleRemoveEducation = (id, index) => {
    
        if (index === 0) {
            alert("First Education cannot be removed.");
            return;
        }

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this Education?"
        );

        if (!confirmDelete) return;

        setEducationList((prev) =>
            prev.filter((item) => item.id !== id)
        );

        if (editingEducationId === id) {
            setEditingEducationId(null);
        }
    };


    const handleSkillChange = (index, field, value) => {
        const updatedSkills = [...skills];
        updatedSkills[index][field] = value;
        setSkills(updatedSkills);
    };

  
    const addSkill = () => {
        const newSkill = {
            id: Date.now(),
            name: "",
            rating: 0,
            progress: 0,
            color: "primary",
        };
        setSkills([...skills, newSkill]);
        setEditingSkillId(newSkill.id);
    };

    const removeSkill = (index) => {
        const updatedSkills = skills.filter((_, i) => i !== index);
        setSkills(updatedSkills);
        if (skills[index]?.id === editingSkillId) {
            setEditingSkillId(null);
        }
    };


    const handleAddEducation = () => {

        const hasIncomplete = educationList.some(
            (item) =>
                !item.university?.trim() ||
                !item.course?.trim() ||
                !item.location?.trim() ||
                !item.startDate
        );

        if (hasIncomplete) {
            alert("Please complete the current Education before adding new one.");
            return;
        }

        const newItem = {
            id: Date.now(),
            university: "",
            course: "",
            location: "",
            startDate: "",
            endDate: "",
            status: "Pursuing"
        };

        setEducationList((prev) => [...prev, newItem]);
        setEditingEducationId(newItem.id);
    };

    return (
        <>
            <div className="GContent-single">
                <h5>Biography</h5>
               <p>
                    Hi, I am<strong> Akhilesh,</strong> a professional Software Developer with 3+ years of experience.
                    I can develop responsive websites, web applications, dashboards, frontend interfaces, backend systems, API integrations, and custom software solutions.
                    If you need any help just give me a knock. Looking forward to working with you!
            </p>
            <p>
                I am passionate about creating modern, scalable, and user-friendly software solutions that help businesses grow online.
                With strong experience in frontend and backend development, I focus on clean code, responsive design, and high-performance applications.
                I always aim to deliver quality work on time and ensure client satisfaction through clear communication and professional support.
            </p>
                <div className="divider"></div>
                {/* Work Experience */}
      
        <section className="GWorkExperience-section">
            <div className="divider"></div>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                <h4 className="mb-0 mt-2 fw-bold">Work Experience</h4>

                <button
                    type="button"
                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{ width: "40px", height: "40px", minWidth: "40px" }}
                    onClick={handleAddExperience}
                >
                    <i className="bi bi-plus-lg"></i>
                </button>
            </div>

           <div className="row g-4 justify-content-start align-items-start">

                {workExperience.map((item, index) => (

                    <div
                        key={item.id}
                        className="col-12 col-sm-12 col-md-6 col-xl-4"
                    >

                        {editingWorkId  === item.id ? (

                            <div
                                className="p-3 p-md-4 rounded-4 position-relative"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                                    border: "1px solid #f1f1f1",
                                    minHeight: "320px"
                                }}
                            >

                                {/* DELETE ICON (top-right slightly outside) */}
                                {index !== 0 && (
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm rounded-circle position-absolute"
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                            top: "-10px",
                                            right: "-10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                            zIndex: 2
                                        }}
                                        onClick={() => handleRemoveExperience(item.id, index)}
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                )}

                                <input
                                    type="text"
                                    className={`form-control form-control-sm mb-3 ${
                                        experienceErrors.company ? "is-invalid" : ""
                                    }`}
                                    value={item.company}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "company", e.target.value)
                                    }
                                    placeholder="Company Name"
                                />

                                {experienceErrors.company && (
                                    <small className="text-danger">{experienceErrors.company}</small>
                                )}

                                <input
                                    type="text"
                                    className={`form-control form-control-sm mb-3 ${
                                        experienceErrors.role ? "is-invalid" : ""
                                    }`}
                                    value={item.role}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "role", e.target.value)
                                    }
                                    placeholder="Role"
                                />

                                {experienceErrors.role && (
                                    <small className="text-danger">{experienceErrors.role}</small>
                                )}

                                <textarea
                                    className="form-control form-control-sm mb-3"
                                    rows="4"
                                    value={item.description}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "description", e.target.value)
                                    }
                                    placeholder="Job Description"
                                    style={{ resize: "none" }}
                                />

                                <input
                                    type="text"
                                    className={`form-control form-control-sm mb-3 ${
                                        experienceErrors.location ? "is-invalid" : ""
                                    }`}
                                    value={item.location}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "location", e.target.value)
                                    }
                                    placeholder="Location"
                                />

                                {experienceErrors.location && (
                                    <small className="text-danger">{experienceErrors.location}</small>
                                )}

                                <input
                                    type="date"
                                    className={`form-control form-control-sm mb-3 ${
                                        experienceErrors.startDate ? "is-invalid" : ""
                                    }`}
                                    value={item.startDate}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "startDate", e.target.value)
                                    }
                                />

                                {experienceErrors.startDate && (
                                    <small className="text-danger">{experienceErrors.startDate}</small>
                                )}

                                <select
                                    className="form-select form-select-sm mb-3"
                                    value={item.durationType}
                                    onChange={(e) =>
                                        handleExperienceChange(index, "durationType", e.target.value)
                                    }
                                >
                                    <option value="Present">Present</option>
                                    <option value="Completed">Completed</option>
                                </select>

                                <button
                                    className="btn btn-success btn-sm w-100"
                                    onClick={() => handleSaveExperience(item, index)}
                                >
                                    Save Changes
                                </button>
                            </div>

                        ) : (

                            <div
                               className="p-3 p-md-4 rounded-4 position-relative"
                                style={{
                                    background: "#ffffff",
                                    boxShadow: "0 8px 25px rgba(0,0,0,0.07)",
                                    border: "1px solid #f1f1f1",
                                    transition: "0.3s ease",
                                    minHeight: "280px"
                                }}
                            >

                                
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm rounded-circle position-absolute"
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        top: "10px",
                                        right: "10px"
                                    }}
                                    onClick={() => setEditingWorkId(item.id)}
                                >
                                    <i className="bi bi-pencil"></i>
                                </button>

                                <h6 className="fw-bold mb-1">
                                    {item.company}
                                </h6>

                                {item.role?.trim() && (
                                    <span className="badge bg-primary-subtle text-primary">
                                        {item.role}
                                    </span>
                                )}

                                {item.location?.trim() && (
                                    <div className="text-muted small mt-3">
                                        <i className="bi bi-geo-alt me-1"></i>
                                        {item.location}
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">

                                    {item.startDate && (
                                        <span className="badge bg-success-subtle text-success">
                                            {item.startDate}
                                        </span>
                                    )}

                                    <span className={`badge ${
                                        item.durationType === "Present"
                                            ? "bg-success"
                                            : "bg-secondary"
                                    }`}>
                                        {item.durationType}
                                    </span>

                                </div>

                                {item.description?.trim() && (
                                    <p className="text-muted small mt-3 mb-0">
                                        {item.description}
                                    </p>
                                )}

                            </div>

                        )}

                    </div>

                ))}

            </div>
        </section>
                <div className="divider"></div>
                <h4 className="mt-30 mb-30 fw-bold">Work Process</h4>
                <img src={mediaUrl + "work-order-management-process.svg?" + sasToken} alt="jobhub" />
                <div className="divider"></div>
        {/* Education */}
       <section className="GEducation-section">
            <div className="divider"></div>

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h4 className="mt-30 mb-2 mb-sm-0 fw-bold">Education</h4>

                <button
                    type="button"
                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{ width: "38px", height: "38px" }}
                    onClick={handleAddEducation}
                >
                    <i className="bi bi-plus-lg"></i>
                </button>
            </div>

            <div className="row g-4 align-items-start">
                {educationList.map((item, index) => (
                    <div
                        key={item.id}
                        className="col-lg-6 col-md-6 col-12"
                    >
                        <div
                            className="p-3 rounded-4 position-relative h-100"
                            style={{
                                background: "#fff",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                                border: "1px solid #eee"
                            }}
                        >
                           
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm rounded-circle position-absolute top-0 end-0 m-2"
                                style={{ width: "32px", height: "32px" }}
                                onClick={() => setEditingEducationId(item.id)}
                            >
                                <i className="bi bi-pencil"></i>
                            </button>

                            {editingEducationId === item.id ? (
                                <>
                                    
                                    <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm rounded-circle"
                                            style={{ width: "32px", height: "32px" }}
                                            onClick={() =>
                                                handleRemoveEducation(item.id, index)
                                            }
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </div>

                                   
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm mb-3 ${
                                            educationErrors.university
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        value={item.university}
                                        onChange={(e) =>
                                            handleEducationChange(
                                                index,
                                                "university",
                                                e.target.value
                                            )
                                        }
                                        placeholder="University"
                                    />

                                    {educationErrors.university && (
                                        <small className="text-danger mb-0">
                                            {educationErrors.university}
                                        </small>
                                    )}

                                   
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm mb-3 ${
                                            educationErrors.course
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        value={item.course}
                                        onChange={(e) =>
                                            handleEducationChange(
                                                index,
                                                "course",
                                                e.target.value
                                            )
                                        }
                                        placeholder="Course"
                                    />

                                    {educationErrors.course && (
                                        <small className="text-danger mb-0">
                                            {educationErrors.course}
                                        </small>
                                    )}

                                    
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm mb-3 ${
                                            educationErrors.location
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        value={item.location}
                                        onChange={(e) =>
                                            handleEducationChange(
                                                index,
                                                "location",
                                                e.target.value
                                            )
                                        }
                                        placeholder="Location"
                                    />

                                    {educationErrors.location && (
                                        <small className="text-danger mb-0">
                                            {educationErrors.location}
                                        </small>
                                    )}

                                   
                                    <div className="row g-2">
                                        <div className="col-6">
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm ${
                                                    educationErrors.startDate
                                                        ? "is-invalid"
                                                        : ""
                                                }`}
                                                value={item.startDate}
                                                onChange={(e) =>
                                                    handleEducationChange(
                                                        index,
                                                        "startDate",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>

                                        <div className="col-6">
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm ${
                                                    educationErrors.endDate
                                                        ? "is-invalid"
                                                        : ""
                                                }`}
                                                value={item.endDate}
                                                onChange={(e) =>
                                                    handleEducationChange(
                                                        index,
                                                        "endDate",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>

                                    {educationErrors.startDate && (
                                        <small className="text-danger d-block mt-1">
                                            {educationErrors.startDate}
                                        </small>
                                    )}

                                    {educationErrors.endDate && (
                                        <small className="text-danger d-block mt-1">
                                            {educationErrors.endDate}
                                        </small>
                                    )}

                                   
                                    <select
                                        className="form-select form-select-sm mt-3"
                                        value={item.status}
                                        onChange={(e) =>
                                            handleEducationChange(
                                                index,
                                                "status",
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="Pursuing">
                                            Pursuing
                                        </option>
                                        <option value="Completed">
                                            Completed
                                        </option>
                                    </select>

                                   
                                    <button
                                        className="btn btn-success btn-sm w-100 mt-3"
                                        onClick={() =>
                                            handleSaveEducation(item, index)
                                        }
                                    >
                                        Save
                                    </button>
                                </>
                            ) : (
                                <>
                                    
                                    <h6 className="fw-bold mb-1">
                                        {item.university}
                                    </h6>

                                    <div className="text-muted small">
                                        {item.course}
                                    </div>

                                    <div className="text-muted small">
                                        {item.location}
                                    </div>

                                    <div className="mt-2 d-flex justify-content-between flex-wrap gap-2">
                                        <span className="badge bg-primary">
                                            {item.startDate}
                                        </span>

                                        <span
                                            className={`badge ${
                                                item.status === "Completed"
                                                    ? "bg-success"
                                                    : "bg-warning text-dark"
                                            }`}
                                        >
                                            {item.status || "Pursuing"}
                                        </span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
       </section>
                <div className="divider"></div>
         {/* Professional Skills */}
        <section className="professional-skills-section">
            <div className="divider"></div>

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">

                <h4 className="mb-10 mt-30 fw-bold">Professional Skills</h4>

                <button
                    type="button"
                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{ width: "38px", height: "38px" }}
                    onClick={addSkill}
                >
                    <i className="bi bi-plus-lg"></i>
                </button>

            </div>

            <div className="GBlock-progress-status mt-4">

                {skills.map((skill, index) => (

                    <div
                        className="GItem-progress mb-4 border rounded p-3 position-relative"
                        key={skill.id}
                    >
                        <div
                            className="position-absolute  d-flex gap-2"
                            style={{ top: "-12px",right: "-10px",zIndex: 2 }}
                        >
                            {editingSkillId === skill.id ? (
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm rounded-circle d-flex align-items-center justify-content-center shadow"
                                    style={{width: "31px",height: "31px",padding: "0"}}
                                    onClick={() => removeSkill(index)}
                                >
                                    <i className="bi bi-trash"></i>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm rounded-circle d-flex align-items-center justify-content-center shadow"
                                    style={{width: "31px",height: "31px",padding: "0"}}
                                    onClick={() => setEditingSkillId(skill.id)}
                                >
                                    <i className="bi bi-pencil"></i>
                                </button>
                            )}
                        </div>
                        {editingSkillId === skill.id ? (

                            <div className="row g-3 align-items-center mt-2">

                                <div className="col-12 col-md-3">

                                    <input
                                        type="text"
                                        className="form-control"
                                        value={skill.name}
                                        onChange={(e) =>
                                            handleSkillChange(index, "name", e.target.value)
                                        }
                                        placeholder="Skill Name"
                                    />

                                </div>

                                <div className="col-6 col-md-2">

                                    <input
                                        type="number"
                                        className="form-control"
                                        min="0"
                                        max="10"
                                        step="0.1"
                                        value={skill.rating}
                                        onChange={(e) =>
                                            handleSkillChange(index, "rating", e.target.value)
                                        }
                                        placeholder="Rating"
                                    />

                                </div>
                                <div className="col-12 col-md-5">

                                    <span className={`badge bg-${skill.color} p-2 fs-6 w-100`}>
                                        {skill.name} - {skill.progress}%
                                    </span>

                                </div>
                                {/* <div className="col-6 col-md-2 ">

                                    <input
                                        type="number"
                                        className="form-control"
                                        min="0"
                                        max="100"
                                        value={skill.progress}
                                        onChange={(e) =>
                                            handleSkillChange(index, "progress", e.target.value)
                                        }
                                        placeholder="Progress"
                                    />

                                </div>

                                <div className="col-12 col-md-3">

                                    <select
                                        className="form-select"
                                        value={skill.color}
                                        onChange={(e) =>
                                            handleSkillChange(index, "color", e.target.value)
                                        }
                                    >
                                        <option value="primary">Primary</option>
                                        <option value="info">Info</option>
                                        <option value="success">Success</option>
                                        <option value="warning">Warning</option>
                                        <option value="danger">Danger</option>
                                    </select>

                                </div> */}

                                <div className="col-12 col-md-2">

                                    <button
                                        type="button"
                                        className="btn btn-success w-100"
                                        onClick={() => {
                                            if (!skill.name?.trim() || !skill.rating) return;
                                            setEditingSkillId(null);
                                        }}
                                    >
                                        Save
                                    </button>

                                </div>

                            </div>

                        ) : (

                        <div className="row align-items-center">

                                <div className="col-12 col-md-4 mb-2 mb-md-0">

                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

                                        <strong className="text-md-bold">
                                            {skill.name}
                                        </strong>

                                        <span
                                            className={`badge ${
                                                skill.rating >= 8
                                                    ? "bg-success"
                                                    : skill.rating >= 6
                                                    ? "bg-primary"
                                                    : skill.rating >= 4
                                                    ? "bg-warning text-dark"
                                                    : "bg-danger"
                                            }`}
                                        >
                                            {skill.rating}/10
                                        </span>

                                    </div>

                                </div>

                                <div className="col-12 col-md-8">

                                    <div
                                        className="progress"
                                        style={{
                                            height: "12px",
                                            borderRadius: "30px",
                                            background: "#e9ecef",
                                            overflow: "hidden"
                                        }}
                                    >

                                        <div
                                            className={`progress-bar ${
                                                skill.progress >= 80
                                                    ? "bg-success"
                                                    : skill.progress >= 60
                                                    ? "bg-primary"
                                                    : skill.progress >= 40
                                                    ? "bg-warning"
                                                    : "bg-danger"
                                            }`}
                                            role="progressbar"
                                            style={{
                                                width: `${skill.progress}%`,
                                                borderRadius: "30px",
                                                transition: "0.4s ease"
                                            }}
                                        ></div>

                                    </div>

                                    <div className="d-flex justify-content-between mt-1">

                                        <small className="text-muted">
                                            Skill Progress
                                        </small>

                                        <small className="fw-semibold">
                                            {skill.progress}%
                                        </small>

                                    </div>

                                </div>

                            </div>

                        )}

                    </div>

                ))}

            </div>
        </section>
            </div>
            {/* -- -------------------------------------- -- */}
        <section className="GApply-jobs py-3 py-md-4">
            <div className="container-fluid">
                <div className="row g-3 align-items-center">

                    <div className="col-12 col-md-5 d-flex flex-column flex-sm-row gap-2">

                        <button
                            type="button"
                            className="btn btn-primary w-100 w-sm-auto"
                        >
                            Hire Now
                        </button>

                        <button
                            type="button"
                            className="btn btn-outline-secondary w-100 w-sm-auto"
                        >
                            Save
                        </button>

                    </div>

                    <div className="col-12 col-md-7">

                        <div className="d-flex flex-wrap justify-content-start justify-content-md-end gap-2 social-share">

                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                            >
                                <img
                                    alt="share"
                                    src={mediaUrl + "share-fb.svg?" + sasToken}
                                />
                                Share
                            </button>

                            <button
                                type="button"
                                className="btn btn-outline-info btn-sm d-flex align-items-center gap-2"
                            >
                                <img
                                    alt="tweet"
                                    src={mediaUrl + "share-tw.svg?" + sasToken}
                                />
                                Tweet
                            </button>

                            <button
                                type="button"
                                className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
                            >
                                <img
                                    alt="pin"
                                    src={mediaUrl + "share-pinterest.svg?" + sasToken}
                                />
                                Pin
                            </button>

                        </div>

                    </div>

                </div>
            </div>
        </section>
        </>
    )

}
export default GCandidateInfo;